const getType = (typeFamily) => {

	const typeFamilyList = {
		"Casas": "House",
		"Departamento": "Apartment",
		// "Oficina": "Office",
		// "Local Comercial": "Store",
		// "Terreno": "Land",
		// "Parcela": "Land",
		// "Agrícola": "Land",
		// "Industrial": "Land",
		// "Bodega": "Warehouse",
		"Estacionamiento": "ParkingFacility",
		"Vacacional": "Apartment"
	}
	return typeFamilyList[typeFamily] ?? ""
}

const getPropertyEntry = (property, type) => {
	const {
		titulo,
		comuna,
		urlFicha,
		imagenPrincipal,
		region,
	} = property ?? {};

	const {
		src: srcImagenPrincipal
	} = imagenPrincipal ?? {};

	return {
		"@type": type,
		"name": titulo,
		"@id": urlFicha,
		"url": urlFicha,
		"image": srcImagenPrincipal,
		"address": {
			"@type": "PostalAddress",
			"addressLocality": comuna,
			"addressRegion": region,
			"addressCountry": "Chile"
		}
	}
}

const getPropertiesList = (propertiesList, propertyType) => {

	const propertyObject = propertiesList.map((property) => {
		let propertyDataObj = undefined

		// Casas, Departamento, Vacacional
		if (propertyType === "House" || propertyType === "Apartment") {

			const {
				dormitorios,
				bannos,
			} = property ?? {};

			propertyDataObj = {
				...getPropertyEntry(property, propertyType),
				"numberOfBedrooms": dormitorios[0],
				"numberOfBathroomsTotal": bannos[0],
			}
		}

		// Estacionamiento
		else if (propertyType === "ParkingFacility") {
			propertyDataObj = getPropertyEntry(property, propertyType)
		}

		// // Oficina
		// if (tipoPropiedad === "Oficina") {
		// 	propertyDataObj = `{
		// 		"@type": "${propertyType}",
		// 		"name": "${titulo}",
		// 		"@id": "${urlFicha}",
		// 		"numberOfRooms": "${dormitorios}",
		// 		"numberOfBathroomsTotal": "${bannos[0]}",
		// 		"url": "${urlFicha}",
		// 		"image": "${srcImagenPrincipal}",
		// 		"address": {
		// 			"@type": "PostalAddress",
		// 			"addressLocality": "${comuna}",
		// 			"addressRegion": "${region}",
		// 			"addressCountry": "Chile"
		// 		}
		// 	}`
		// }

		// // Bodega, Local Comercial
		// if (tipoPropiedad === "Bodega" || tipoPropiedad === "Local Comercial") {
		// 	propertyDataObj = `{
		// 		"@type": "${propertyType}",
		// 		"name": "${titulo}",
		// 		"@id": "${urlFicha}",
		// 		"floorSize": "${superficie}",
		// 		"url": "${urlFicha}",
		// 		"image": "${srcImagenPrincipal}",
		// 		"address": {
		// 			"@type": "PostalAddress",
		// 			"addressLocality": "${comuna}",
		// 			"addressRegion": "${region}",
		// 			"addressCountry": "Chile"
		// 		}
		// 	}`
		// }

		// // Terreno, Parcela, Agrícola e Industrial
		// if (tipoPropiedad === "Terreno" || tipoPropiedad === "Parcela" || tipoPropiedad === "Agrícola" || tipoPropiedad === "Industrial") {
		// 	propertyDataObj = `{
		// 		"@type": "${propertyType}",
		// 		"name": "${titulo}",
		// 		"@id": "${urlFicha}",
		// 		"landArea": "${superficie}",
		// 		"url": "${urlFicha}",
		// 		"image": "${srcImagenPrincipal}",
		// 		"address": {
		// 			"@type": "PostalAddress",
		// 			"addressLocality": "${comuna}",
		// 			"addressRegion": "${region}",
		// 			"addressCountry": "Chile"
		// 		}
		// 	}`
		// }
		return propertyDataObj;
	})
	return propertyObject.filter( p => p) // Clear undefined
}

export const getSchema = (propertiesList) => {

	if ( propertiesList === null || propertiesList === undefined || propertiesList.length === 0)
		return "";

	const {
		comuna,
		tipoPropiedad
	} = propertiesList[0] ?? {};

	const propertyType = getType(tipoPropiedad)

	if (propertyType === "")
		return "";

	const searchResultPageSchema = {
		"@context": "http://schema.org",
		"@type": "SearchResultsPage",
		"contentLocation": {
			"@type": "City",
			"name": comuna
		},
		"about": [
			getPropertiesList(propertiesList, propertyType)
		]
	}

	return JSON.stringify(searchResultPageSchema)
}